import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef
} from '@angular/core';
import {
    BUTTON_ICON_POSITION,
    BUTTON_SUB_TYPE,
    BUTTON_TYPE,
    LibButtonComponent
} from "../button/lib-button/lib-button.component";
import {NgTemplateOutlet} from "@angular/common";

@Component({
    selector: 'lib-bottom-toolbar',
    standalone: true,
    imports: [
        LibButtonComponent,
        NgTemplateOutlet
    ],
    templateUrl: './lib-bottom-toolbar.component.html',
    styleUrl: './lib-bottom-toolbar.component.scss'
})
export class LibBottomToolbarComponent implements OnInit, OnChanges {

    @Input() libBottomToolbarConfig: LibBottomToolbarConfig;
    @Input() isLoading: boolean;
    @Input() allowAutoHide = true;

    @Output() onClicked: EventEmitter<string> = new EventEmitter<string>();

    isToolbarHidden = false;

    protected readonly BUTTON_SUB_TYPE = BUTTON_SUB_TYPE;
    protected readonly LibBottomToolbarBottomConfigType = LibBottomToolbarBottomConfigType;

    private lastScrollY = 0;
    private readonly minScrollDistanceForTriggerScroll = 10;

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {
        this.isLoading = changes?.['isLoading']?.currentValue;
    }

    @HostListener('window:scroll')
    onWindowScroll(): void {
        if (!this.allowAutoHide) {
            return;
        }
        const {isHidden, newLastScrollY} = this.calculateToolbarVisibility({
            lastScrollY: this.lastScrollY,
            scrollThreshold: this.minScrollDistanceForTriggerScroll,
            isCurrentlyHidden: this.isToolbarHidden
        });

        this.isToolbarHidden = isHidden;
        this.lastScrollY = newLastScrollY;
    }

    onSubmitLibButton(buttonId: string): void {
        this.onClicked.emit(buttonId);
    }

    private calculateToolbarVisibility(scrollState: ScrollState): ScrollVisibilityResult {
        const {lastScrollY, scrollThreshold, isCurrentlyHidden} = scrollState;
        const currentScrollY = window.scrollY;

        if (Math.abs(currentScrollY - lastScrollY) <= scrollThreshold) {
            return {isHidden: isCurrentlyHidden, newLastScrollY: lastScrollY};
        }

        if (currentScrollY <= 50) {
            return {isHidden: false, newLastScrollY: currentScrollY};
        }

        const shouldBeHidden = currentScrollY > lastScrollY;
        return {isHidden: shouldBeHidden, newLastScrollY: currentScrollY};
    }
}

export interface LibBottomToolbarConfig {
    libBottomToolbarBottomConfigs: LibBottomToolbarBottomConfig[];
}

export interface LibBottomToolbarBottomConfig {
    id: string,
    type: LibBottomToolbarBottomConfigType,
    buttonText?: string;
    tooltip?: string;
    buttonType?: BUTTON_TYPE;
    buttonSubType?: BUTTON_SUB_TYPE;
    iconClass?: string;
    iconImage?: string;
    iconPosition?: BUTTON_ICON_POSITION;
    customTemplateRef?: TemplateRef<any>;
}

export enum LibBottomToolbarBottomConfigType {
    BUTTON = 'BUTTON',
    CUSTOM = 'CUSTOM',
}

export interface ScrollState {
    lastScrollY: number;
    scrollThreshold: number;
    isCurrentlyHidden: boolean;
}

export interface ScrollVisibilityResult {
    isHidden: boolean;
    newLastScrollY: number;
}
